
// @ts-nocheck
import locale__builds_web_dev_front_academica_academgen_i18n_ru_ts from "../i18n/ru.ts";
import locale__builds_web_dev_front_academica_academgen_i18n_kz_ts from "../i18n/kz.ts";


export const localeCodes =  [
  "ru",
  "kz"
]

export const localeLoaders = {
  "ru": [{ key: "../i18n/ru.ts", load: () => Promise.resolve(locale__builds_web_dev_front_academica_academgen_i18n_ru_ts), cache: true }],
  "kz": [{ key: "../i18n/kz.ts", load: () => Promise.resolve(locale__builds_web_dev_front_academica_academgen_i18n_kz_ts), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "ru",
      "files": [
        "i18n/ru.ts"
      ]
    },
    {
      "code": "kz",
      "files": [
        "i18n/kz.ts"
      ]
    }
  ],
  "defaultLocale": "ru",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "i18n/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ru",
    "files": [
      {
        "path": "i18n/ru.ts"
      }
    ]
  },
  {
    "code": "kz",
    "files": [
      {
        "path": "i18n/kz.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
